export default __webpack_public_path__ + "static/media/firebase.18e8cd69.png";